<template>
  <div class="block-t">
    <div class="block-t__content">
      <div class="block-t__image rellax" data-rellax-speed="0.4" data-rellax-percentage="0.4">
        <img src="../assets/img/block-t-1.jpg" alt="">
        <img src="../assets/img/block-t-2.jpg" class="flash" alt="">
      </div>
      <div class="block-t__letter letter letter-line" data-aos="fade-up">
        Т.
      </div>
      <div class="block-t__info" data-aos="fade-up">
        <div class="block-t__title">Теат<span>[р]</span></div>
        <div class="block-t__text text text-white">Заветной мечтой Вертинского с детства было поступить <br>в Московский художественный театр. Но ей не суждено было сбыться. В 1913 году Вертинский провалил вступительные испытания из-за дефекта дикции: <br>не кто-нибудь, а сам К. С. Станиславский, принимавший экзамен, заявил, что с таким плохим звуком [р], <br>путь в МХТ закрыт.</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlockV'
}
</script>

<style lang="sass">
  .block-t
    padding-top: vw(96px)
    padding-bottom: vw(59px)
    &__content
      display: flex
      padding-left: vw(110px)
    &__image  
      width: vw(532px)
      min-width: vw(532px)
      position: relative
      img
        width: 100%
        &.flash
          position: absolute
          width: vw(532px)
          left: 0
          animation: showHide
          animation-duration: 5000ms
          animation-timing-function: linear
          animation-iteration-count: infinite
      &:after
        content: ''
        width: vw(345px)
        height: vw(492px)
        position: absolute
        background-image: url(../assets/img/block-t-el.png)
        background-size: contain
        background-repeat: no-repeat
        left: vw(-93px)
        top: vw(-65px)
    &__letter
      margin-left: vw(-131px)
      margin-top: vw(33px)
      padding-top: vw(13px)
      padding-left: vw(20px)
    &__title
      font-size: vw(72px)
      color: #fff
      font-family: 'ZnikomitNo25'
      margin-bottom: vw(51px)
      span
        color: #E1C99C
    &__info
      margin-left: vw(57px)
      margin-top: vw(73px)
</style>
